/* eslint-disable @typescript-eslint/no-unused-vars */

/** no-op implementation of rudderAnalyticsBrowser */
export const rudderAnalyticsBrowser = {
  load: (...args: any[]) => {},
  identify: (...args: any[]) => {},
  reset: (...args: any[]) => {},
  page: (...args: any[]) => {},
  track: (...args: any[]) => {},
};

let initialized = false;
export const initRudderStack = () => {
  if (initialized) return;

  rudderAnalyticsBrowser.load('', '', {
    plugins: [
      // 'BeaconQueue',
      // 'DeviceModeDestinations',
      'NativeDestinationQueue',
      'StorageEncryption',
      // 'XhrQueue',
    ],
    storage: {
      encryption: {
        version: 'v3',
      },
    },
  });

  initialized = true;
};
